<menu-superior></menu-superior>
<div class="page-wrapper">
    <div class="page-content">
        <router-outlet></router-outlet>
    </div>
</div>

<detecting-connection></detecting-connection>
